//往来企业定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 企业类型
 */
class EnterpriseType extends UltMeta {
    REGISTERED = new Meta(1, "注册企业");
    RECORDED = new Meta(2, "录入企业");
}

export const ENTERPRISE_TYPE = new EnterpriseType();

/**
 * 往来企业类型
 */
class Initiator extends UltMeta {
    CUSTOMER = new Meta(1, "客户");
    SUPPLIER_CHAIN = new Meta(2, "供应链");
}

export const INITIATOR = new Initiator();

class State extends UltMeta {
    TO_BE_CONFIRMED = new Meta(1, "待确认/确认中");
    REJECTED = new Meta(2, "已驳回");
    COOPERATION = new Meta(3, "合作中");
}

export const STATE = new State();

class QueryState extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    TO_BE_CONFIRMED = new Meta(2, "待确认");
    COOPERATION = new Meta(3, "合作中");
    REJECTED = new Meta(4, "已驳回");
}

export const QUERY_STATE = new QueryState();

/**
 * 主体类型
 */
class BodyType extends UltMeta {
    CUSTOMER = new Meta(1, "客户");
    SUPPLIER_CHAIN = new Meta(2, "供应链");
}

export const BODY_TYPE = new BodyType();
